export default "__VITE_ASSET__CXlVa7zG__"